import start from '@/store/modules/interactions/rounds/start';

export default {
    start,
};
